import { usePageHeader } from '@hooks/useHeader'
import useTypedTranslation from '@hooks/useTypedTranslation'
import StoreInventoryUpload from '@routes/StoreManagement/StoreInventoryUpload'

function StoreManagementRoute() {
  const { t } = useTypedTranslation()
  usePageHeader({ title: t('storeManagement.title'), showQuickSelection: false })
  return <StoreInventoryUpload />
}

export default StoreManagementRoute